import axios from 'axios';

const BASE_URL = 'https://games.ibitplay.com';

const api = axios.create({
  baseURL: BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const login = (username: string, password: string) =>
  api.post('/api/auth/login', { username, password });

export const registerClient = (data: any) =>
  api.post('/api/client/register', data);

export const updateClient = (data: any) =>
  api.put('/api/client/update', data);

export const deleteClient = (data: { client_id: number }) =>
  api.delete('/api/client/delete', { data });

export const getClientData = (clientId?: number) =>
  api.get('/api/client/data', { params: clientId ? { client_id: clientId } : undefined });

export const getClientBalance = (clientId?: number) =>
  api.get('/api/client/balance', { params: clientId ? { client_id: clientId } : undefined });

export const listClients = () => api.get('/api/client/list');

export const listClientVendors = (clientId: number) =>
  api.get('/api/admin/client/vendors', { params: { client_id: clientId } });

export const toggleClientVendor = (
  clientId: number,
  vendor: string,
  enabled: boolean,
  disabledGameIds?: number[]
) =>
  api.post('/api/admin/client/vendors/toggle', {
    client_id: clientId,
    vendor_id: vendor,
    enabled,
    disabled_game_ids: disabledGameIds,
  });

export const updatePrioritizedGames = (vendor: string, game_ids: number[]) =>
  api.post('/api/admin/prioritized-games', { vendor, game_ids });

export const getPrioritizedGames = () => api.get('/api/admin/prioritized-games');

export const getApiLogs = (clientId?: number) =>
  api.get('/api/admin/api-logs', { params: clientId ? { client_id: clientId } : undefined });

export const getUserHistory = (client_user_id: number) =>
  api.get('/api/user/history', { params: { client_user_id } });

// Deposit APIs
export interface DepositAddress {
  id: number;
  currency: string;
  chain: string;
  address: string;
  qr_code?: string;
  active: number;
}
export const getDepositAddresses = () => 
  api.get<{success: boolean, data: DepositAddress[]}>('/api/deposits/addresses');

export const submitDepositRequest = (formData: FormData) =>
  api.post<{
      message: string;success: boolean
}>('/api/deposits/request', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

  export const getDepositHistory = (clientId: number) =>
    api.get('/api/deposits/history/'+clientId);

export default api;